import { TransferScheduleState, TransferScheduleAction } from './transferSchedule.types';

export const initialState: TransferScheduleState = {
  timeSlots: [],
  timeWindows: [],
  selectedTimeSlot: {
    activityType: '',
    endRange: '',
    optionId: '',
    routeId: '',
    time: '',
    utcStartTime: 0
  },
  isFlexibleDelivery: true,
  vinEtchingState: '',
  vinEtchingError: false,
  vinEtchingLoading: false,
  vinEtchingErrorModalOpen: false,
  dataLoaded: false
};

export const transferScheduleReducer = (
  state: TransferScheduleState,
  action: TransferScheduleAction
) => {
  switch (action.type) {
    case 'SET_TIME_SLOTS':
      return {
        ...state,
        timeSlots: action.payload.timeSlots,
        timeWindows: action.payload.timeWindows,
        isFlexibleDelivery: action.payload.isFlexibleDelivery,
        vinEtchingState: action.payload.vinEtchingState
      };
    case 'SET_DATA_LOADED':
      return {
        ...state,
        dataLoaded: action.payload.dataLoaded
      };
    case 'SELECT_DATE':
      return {
        ...state,
        selectedTimeSlot: {
          activityType: '',
          date: action.payload.date,
          endRange: '',
          optionId: '',
          routeId: '',
          time: '',
          utcStartTime: 0
        }
      };
    case 'SELECT_TIME':
      return {
        ...state,
        selectedTimeSlot: {
          ...state.selectedTimeSlot,
          activityType: action.payload.activityType,
          endRange: action.payload.endRange,
          optionId: action.payload.optionId,
          routeId: action.payload.routeId,
          time: action.payload.time,
          utcStartTime: action.payload.utcStartTime
        }
      };
    case 'DECLINE_VIN_ETCHING_START':
      return {
        ...state,
        vinEtchingError: false,
        vinEtchingLoading: true
      };
    case 'DECLINE_VIN_ETCHING_SUCCESS':
      return {
        ...state,
        vinEtchingState: 'Declined',
        vinEtchingError: false,
        vinEtchingLoading: false
      };
    case 'DECLINE_VIN_ETCHING_ERROR':
      return {
        ...state,
        vinEtchingError: true,
        vinEtchingLoading: false
      };
    case 'OPEN_VIN_ETCHING_ERROR_MODAL':
      return {
        ...state,
        vinEtchingErrorModalOpen: true
      };
    case 'CLOSE_VIN_ETCHING_ERROR_MODAL':
      return {
        ...state,
        vinEtchingErrorModalOpen: false
      };
    default:
      throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
  }
};
